import { onCLS, onINP, onLCP, onTTFB } from 'web-vitals';
import type { ClientVitalsInput } from '@avslack/shared';
import { apiFetch } from './api';

/**
 * A felület sebessége a KOLLÉGA gépén.
 *
 * A szerver minden mérése a szerverről szól: a terheléses próba a konténerben
 * a localhostot hívja, a Prometheus a válaszidőt látja. Ami abból nem derül
 * ki: mennyi idő alatt jelenik meg az üzenetlista a betöltés után, és mennyit
 * késik egy kattintás - a proxyval, a TLS-szel, az irodai hálózattal és a gép
 * lassúságával együtt. Ha valaki azt mondja, "lassú", ebből dönthető el, hogy
 * a szerver vagy a kliens oldala az.
 *
 * Oldalbetöltésenként EGY beacon megy, amikor a lap elrejtődik vagy bezárul
 * (a web-vitals ekkor adja a végleges LCP/INP/CLS értéket), legkésőbb pedig
 * egy perc után. Tartalom nincs benne, csak milliszekundumok.
 */

const FLUSH_AFTER_MS = 60_000;

/** Az üzenetlista első megjelenéséig eltelt idő - a chat "kész vagyok" pillanata. */
export const FIRST_MESSAGES_MARK = 'avslack:first-messages';

let firstMessagesMarked = false;

/** A MessageList hívja, amikor először vannak üzenetek a képernyőn. */
export function markFirstMessages(): void {
  if (firstMessagesMarked || typeof performance === 'undefined') return;
  firstMessagesMarked = true;
  try {
    performance.mark(FIRST_MESSAGES_MARK);
  } catch {
    // Regi bongeszo: a jelolés hianya nem hiba.
  }
}

export function initVitals(): void {
  if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') return;

  const sample: ClientVitalsInput = {};
  let sent = false;

  onTTFB((metric) => {
    sample.ttfbMs = Math.round(metric.value);
  });
  onLCP((metric) => {
    sample.lcpMs = Math.round(metric.value);
  });
  onINP((metric) => {
    sample.inpMs = Math.round(metric.value);
  });
  onCLS((metric) => {
    sample.cls = Number(metric.value.toFixed(3));
  });

  const send = () => {
    if (sent) return;
    sent = true;

    try {
      const [mark] = performance.getEntriesByName(FIRST_MESSAGES_MARK);
      if (mark) sample.firstMessagesMs = Math.round(mark.startTime);
    } catch {
      // nincs jelolés: marad ures
    }

    // Semmi ertelmes ertek: nem kuldunk ures sort.
    if (Object.values(sample).every((value) => value === undefined)) return;

    // A `keepalive` miatt a keres a lap bezarasa utan is elmegy.
    void apiFetch('/api/client/vitals', {
      method: 'POST',
      body: JSON.stringify(sample),
      keepalive: true,
    }).catch(() => undefined);
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') send();
  });
  window.addEventListener('pagehide', send);
  window.setTimeout(send, FLUSH_AFTER_MS);
}
